// components/WalletButton.js
import { useWeb3 } from '../context/Web3Context';
import { formatAddress } from '../utils/formatters';

export default function WalletButton() {
  const { account, isConnecting, connectWallet, disconnectWallet } = useWeb3();

  if (isConnecting) {
    return (
      <button className="wallet-button" disabled>
        Connecting...
      </button>
    );
  }

  return (
    <button 
      className="wallet-button" 
      onClick={account ? disconnectWallet : connectWallet}
    >
      {account ? `Disconnect ${formatAddress(account)}` : 'Connect Wallet'}
    </button>
  );
}